<template>
<CModal @mtdclosemodal="mtdclosemodal" :show.sync="boo_modal" :close-on-backdrop="false" :centered="true" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
    <div class="inputs px-5 pt-2">
        <div class="row mb-2">
            <div class="col-xl-1">
                <label for=""> <strong> Paciente: </strong></label>
            </div>
            <div class="col-xl-5">
                <input type="text" v-model="patient.name" class="form-control form-control-sm "  disabled >
            </div>
            <div class="col-xl-5">
                <input type="file" class="form-control form-control-sm" @change="handleFileUpload" accept="image/*,application/pdf">
                <small v-if="fileError" class="text-danger">{{ fileError }}</small>
            </div>
        </div>
        <div class="row d-flex ">
            <div class=" mb-3 col-lg-4 col-md-6 ">
                <label for="staticEmail" class="col-form-label">N°</label>
                <input v-model="number_bill" type="text" class="form-control " >
            </div>
            <div class=" mb-3 col-lg-4 col-md-6 ">
                <label for="staticEmail" class="col-form-label">Fecha</label>
                <input v-model="date" type="date" class="form-control "  >
            </div>
            <div class="mb-3 col-lg-4 col-md-6" >
                <label for="exampleFormControlInput11" class="col-form-label">Proveedor</label>
                <v-select
                    class="text-dark form-control"
                    label="name"
                    :options="dataProvider"
                    placeholder="- Buscar Proveedor (Escriba uno...) -"
                    :reduce="(name) => name.id"
                    required
                    :clearable="false"
                    v-model="provider_id"
                    @input="mtddata"
                >
                    <template slot=" no-options">
                    No hay Productos para la busqueda.
                    </template>
                </v-select>
            </div>
        </div>
        <h6> <strong>Detalle de la Factura</strong> </h6>
        <div class="table-responsive">
            <table class="table table-borderless">
                <thead>
                    <tr>
                        <!-- <th colspan="2">Nombre</th> -->
                        <th>Nombre</th>
                        <th>Precio Venta</th>
                        <th>Precio Costo</th>
                        <th>Ganancia</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index1) in montura" :key="index1">
                        <td >{{ item.mount_name }}</td>
                        <!-- <td>
                            <select v-model="item.barcode" class="form-control" @change="updatePrice(index1)">
                                <option value="" disabled>- (Seleccione...) -</option>
                                <option v-for="(option, index) in montura_data" 
                                        :key="index" 
                                        :value="option.barcode">
                                    {{ option.name }}
                                </option>
                            </select>
                        </td> -->
                        <td><input v-model="item.mount_price" type="text" class="form-control" disabled></td>
                        <td><input v-model="item.price_cost" type="text" class="form-control"></td>
                        <td><input :value="getPriceDifference(item)" type="text" class="form-control" disabled></td>
                    </tr>

                    <tr v-if="far !=null">
                        <td >{{ far.lensType }}</td>
                        <td>
                            <!-- <v-select class="text-dark form-control"
                                    label="name"
                                    :options="producto"
                                    placeholder="- (Escriba uno...) -"
                                    :reduce="(name) => name.id"
                                    required
                                    :clearable="false">
                                <template slot="no-options">
                                    No hay Productos para la búsqueda.
                                </template>
                            </v-select> -->
                            <v-select class="text-dark form-control"
                                    label="name"
                                    :options="producto"
                                    placeholder="- (Escriba uno...) -"
                                    :reduce="(option) => option.id"
                                    required
                                    :clearable="false"
                                    @input="updateFarSubId">
                                <template slot="no-options">
                                    No hay Productos para la búsqueda.
                                </template>
                            </v-select>
                        </td>
                        <td><input v-model="far.lensType_price" type="text" class="form-control" disabled></td>
                        <td><input v-model="far.price_cost" type="text" class="form-control"></td>
                        <td><input v-model="priceDifference" type="text" class="form-control" disabled></td>
                    </tr>

                    <tr v-if="near !=null">
                        <td >{{ near.lensType }}</td>
                        <td>
                            <v-select class="text-dark form-control"
                                    label="name"
                                    :options="producto"
                                    placeholder="- (Escriba uno...) -"
                                    :reduce="(option) => option.id"
                                    required
                                    :clearable="false"
                                    @input="updateNearSubId">
                                <template slot="no-options">
                                    No hay Productos para la búsqueda.
                                </template>
                            </v-select>
                        </td>
                        <td><input v-model="near.lensType_price" type="text" class="form-control" disabled></td>
                        <td><input v-model="near.price_cost" type="text" class="form-control"></td>
                        <td><input v-model="priceDifferencenear" type="text" class="form-control" disabled></td>
                    </tr>
                </tbody>
            </table>
        </div>


        
        <!-- central de costos -->
        <div class="d-flex justify-content-end">
            <button type="button" class=" border-0 rounded-2 bg-main px-5 py-2 text-white" @click="addfactura" :disabled="mtddisable" >GUARDAR</button>
        </div>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>

</CModal>

</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import CButtonClose from "@/components/shared/modals/cButtonClose.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import {
    mapActions
} from "vuex";

export default {
    name: "c-vigilancia-modal-control",
    components: {
        CModal,
        CButtonClose,
        SweetAlert
    },
    data() {
        return {
            swal: null,
            provider_id: null,
            dataProvider: [],
            montura_data: [],
            producto:[],
            number_bill: "",
            date: "",
            selectedFile: null,
            fileError: null,
            montura: [],
        };
    },
    computed: {
        priceDifference() {
        return this.far.lensType_price - this.far.price_cost;
        },
        priceDifferencenear() {
         return this.near.lensType_price - this.near.price_cost;
        },
        mtddisable(){
            return !(this.provider_id !=null && this.date !="" && this.number_bill !="") 
        }
        
    },
    watch: {
        purcharseOrder(newvalor, old) {
            this.bill.total = newvalor.pendiente;
        },
        dataMont: {
            immediate: true,
            handler(newValue) {
                this.montura = [...newValue];
            }
        }
    },
    props: {
        title: String,
        boo_modal: Boolean,
        patient: Object,
        dataMont:Array,
        far:Object,
        near:Object,
        work_id: Number,
    },

    created() {
        this.mtdproveedores();
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdproveedores:function(){
            this.get({
                    url: this.$store.getters.get__url + "/logistics/maintenance/provider",
                    token: this.$store.getters.get__token,
                })
                .then((response) => {
                    this.dataProvider = response.data;
                 
                })
                .catch((errors) => {});
        },
        mtdclosemodal() {
            this.provider_id =null,
            this.date = "",
            this.number_bill = "",
            this.montura_data = [],
            this.producto = [],
            this.$emit("closeModalStoreBill");
        },

        mtddata:function(){
            this.post({
                    //url: this.$store.getters.get__url + "/ordenTrabajo/data/"+this.provider_id +'/'+this.$store.getters.get__campus,
                    url: this.$store.getters.get__url + "/ordenTrabajo/data",
                    token: this.$store.getters.get__token,
                    params: {
                        providerId: this.provider_id,
                        campu: this.$store.getters.get__campus,
                        dataMont: this.montura
                    }
                })
                .then((response) => {
                    // this.montura_data = ;
                    /* this.montura_data = response.data.data
                    this.producto =response.data.product */

                    if(response.data.priceProd.length > 0) {
                        this.montura = this.montura.map(item => {
                            const found = response.data.priceProd.find(p => p.product_id === item.product_id);
                            if (found) {
                                return { ...item, price_cost: found.price_cost };
                            }
                            return item;
                        });
                    }
                })
                .catch((errors) => {});
        },
       
        updatePrice(index) {
            const selectedItem = this.montura[index]; 
            const selectedOption = this.montura_data.find(option => option.barcode === selectedItem.barcode);
            if (selectedOption) {
                this.$set(this.montura, index, {
                    ...selectedItem,
                    price_cost: selectedOption.price, // Asigna el price
                    sub_id: selectedOption.id ,
                    product_id:selectedOption.product_id
                     // Asigna el barcode
                });
            }
        },
        getPriceDifference(item) {
         return (item.mount_price || 0) - (item.price_cost || 0);
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                const validTypes = ["image/jpeg", "image/png", "image/gif", "application/pdf"];
                if (!validTypes.includes(file.type)) {
                    this.fileError = "Solo se permiten imágenes (JPG, PNG, GIF) y archivos PDF.";
                    this.selectedFile = null;
                } else {
                    this.fileError = null;
                    this.selectedFile = file;
                    console.log("Archivo válido seleccionado:", this.selectedFile);
                }
            }
        },
        addfactura:function(){
            let formData = new FormData();
            formData.append("provider_id", this.provider_id);
            formData.append("patient_id", this.patient.id);
            formData.append("montura", JSON.stringify(this.montura));
            formData.append("near", JSON.stringify(this.near));
            formData.append("far", JSON.stringify(this.far));
            formData.append("work_id", this.work_id);
            formData.append("number_bill", this.number_bill);
            formData.append("date", this.date);
            formData.append("campu_id", this.$store.getters.get__campus);
            formData.append("file", this.selectedFile);
            this.post({
                    url: this.$store.getters.get__url + "/ordenTrabajo/facturaadd",
                    token: this.$store.getters.get__token,
                    params: formData
                })
                .then((response) => {
                    // 
                    this.mtdclosemodal();
                    this.$refs.SweetAlert.showSuccess("Registro Exitoso");
                    this.$emit("add_exit");
                })
                .catch((errors) => {});
        },
        updateFarSubId(selectedId) {
                const selectedProduct = this.producto.find(prod => prod.id === selectedId);
                if (selectedProduct) {
                    this.far.sub_id = selectedProduct.sub_sub_category_id;
                    this.far.product_id = selectedProduct.id
                }
        },
        updateNearSubId(selectedId) {
                const selectedProduct = this.producto.find(prod => prod.id === selectedId);
                if (selectedProduct) {
                    this.near.sub_id = selectedProduct.sub_sub_category_id;
                    this.near.product_id = selectedProduct.id
                }
        }

    },
};
</script>
<style scoped>
  .v-select{
    padding: 0px;
    border: 0px; 
     }
</style>
